"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalInformationInitRequest = void 0;
var PersonalInformationInitRequest = /** @class */ (function () {
    function PersonalInformationInitRequest() {
    }
    return PersonalInformationInitRequest;
}());
exports.PersonalInformationInitRequest = PersonalInformationInitRequest;
;
//# sourceMappingURL=personalInformationInit.request.js.map